export const setToken = (token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('lastLoginTime', new Date(Date.now()).getTime());
};
export const getToken = () => {
    return localStorage.getItem('token')
}

export const setRole = (role) => {
    localStorage.setItem('role', role);
};
export const getRole = (role) => {
    return localStorage.getItem('role');
};

export const setUserId = (userId) => {
    return localStorage.setItem('userid', userId)
}
export const getUserId = () => {
    return localStorage.getItem('userid')
}
